export const SET_VENDORREWARDS = "SET_VENDORREWARDS";
export const GET_VENDORREWARDS = "GET_VENDORREWARDS";
